import { api } from "config";
import { AuthenticationContext } from "medtankengroup-authentication/context";
import { createContext, useEffect, useState, useContext, useMemo } from "react";

export const MedphotoContext = createContext<MedphotoContextType>({} as MedphotoContextType);

export const MedphotoProvider = ({ children }: { children: any }) => {
  const [units, setUnits] = useState<Unit[]>([]);
  const [selectedUnitOption, setSelectedUnit] = useState<{ id: number; label: string } | null>(null);
  const { user } = useContext(AuthenticationContext);

  useEffect(() => {
    const fetchInitial = async () => {
      const personUnits = user.person_units.map((pu: { unit: { id: number } }) => pu.unit.id);

      const response = await api.get("pal/units/active-journal-system/");
      const unitData = (response.data as Unit[]).filter((u) => personUnits.includes(u.id));
      setUnits(unitData);

      const storedUnitId = window.localStorage.getItem("unit");
      if (storedUnitId) {
        const unitId = parseInt(storedUnitId);
        const unit = unitData.find((u: Unit) => u.id === unitId);
        if (unit) {
          setSelectedUnit({ id: unit.id, label: unit.name });
        }
      }
    };
    fetchInitial();
  }, [user.person_units]);

  const selectUnit = (option: { id: number; label: string } | null) => {
    if (option) {
      setSelectedUnit(option);
      window.localStorage.setItem("unit", option.id.toString());
    } else {
      setSelectedUnit(null);
    }
  };

  const unit = useMemo(() => units.find((u) => u.id === selectedUnitOption?.id) ?? null, [selectedUnitOption, units]);

  return (
    <MedphotoContext.Provider
      value={{
        units,
        unit,
        selectedUnitOption,
        selectUnit,
      }}
    >
      {children}
    </MedphotoContext.Provider>
  );
};
